import 'antd/dist/antd.css'
import 'react-phone-input-2/lib/style.css';
import "antd/dist/antd.less";
import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
// import AmountAvailable from "./PickUpCash/AmountAvailable";
import Complete from "./PickUpCash/Complete";
import Network from "./CreateUser/Network";
import DashboardMain from "../container/DashboardMain";
import Payment from "../container/Payment";
import PaymentCheck from "../container/PaymentCheck";
import PaymentChoice from "../container/CreateUser/PaymentChoice";
import Paypal from "./AddToBalance/FundAccountPaypal";
import CardDetails from "../container/CreateUser/CardDetails"
import Pickup from "./PickUpCash/Pickup";
import LocationSelector from './PickUpCash/LocationSelector';

class Dashboard extends Component {
    render() {
        return (
            <div className="App">
                <Switch>
                    <Route exact path='/dashboard' component={DashboardMain} />
                    <Route path="/dashboard/amount-available" component={LocationSelector} />
                    <Route exact path='/dashboard/complete' component={Complete} />
                    <Route exact path='/dashboard/network' component={Network} />
                    <Route exact path='/dashboard/payment_choice' component={PaymentChoice} />
                    <Route path='/dashboard/card-details' component={CardDetails} />
                    <Route exact path='/dashboard/payment' component={Payment} />
                    <Route exact path='/dashboard/payment-check' component={PaymentCheck} />
                    <Route exact path='/dashboard/pickup' component={Pickup} />
                    <Route exact path='/dashboard/fund-account-paypal' component={Paypal} />
                    <Redirect to={"/dashboard"} exact path='*' />
                </Switch>
            </div>
        );
    }
}

export default Dashboard;
